/* eslint-disable no-param-reassign */
import React, { forwardRef } from 'react'
import MatrixSendMessageComposer from 'matrix-react-sdk/lib/components/views/rooms/SendMessageComposer'
import { useChatComposer } from 'ducks/chat/hooks/composer'

const SendMessageComposer = forwardRef((props, forwardedRef) => {
  const {
    room: { roomId },
  } = props
  const { prepareMessage, enabled } = useChatComposer(roomId, {})
  const { allowAnonymousChat, identifyContactByMatrixId, ...rest } = props

  if (!enabled) return null

  return (
    <MatrixSendMessageComposer
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
      onBeforeSendMessage={prepareMessage}
      showReplyPreview={false}
      ref={forwardedRef}
    />
  )
})

export default SendMessageComposer
